import { render } from "./CreateGame.vue?vue&type=template&id=64a33b9b&scoped=true&lang=pug"
import script from "./CreateGame.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateGame.vue?vue&type=script&setup=true&lang=js"

import "./CreateGame.vue?vue&type=style&index=0&id=64a33b9b&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a33b9b"]])

export default __exports__